// @flow
import deprecatedStyles from './deprecated-styles';

const colors = {
    butter: 'rgb(255, 213, 54)',
    chalk: 'rgb(244, 245, 246)',
    cranberry: 'rgb(225, 41, 72)',
    emerald: 'rgb(61, 232, 171)',
    evening: 'rgb(92, 109, 124)',
    graphite: 'rgb(204, 210, 214)',
    lime: 'rgb(180, 214, 39)',
    merigold: 'rgb(255, 185, 54)',
    midnight: 'rgb(41, 61, 72)',
    orange: 'rgb(255, 122, 0)',
    sapphire: 'rgb(61, 97, 232)',
    slate: 'rgb(51, 73, 91)',
    stone: 'rgb(224, 228, 230)',
    violet: 'rgb(137, 54, 255)',
    white: 'rgb(255, 255, 255)'
};

const fontSizes = {
    fs1: '14px',
    fs2: '16px',
    fs3: '18px',
    fs4: '20px',
    fs5: '24px',
    fs6: '36px',
    fs7: '48px',
    fs8: '60px',
    fs9: '72px'
};
const lineHeights = {
    lh1: '18px',
    lh2: '20px',
    lh3: '22px',
    lh4: '24px',
    lh5: '28px',
    lh6: '40px',
    lh7: '52px',
    lh8: '64px',
    lh9: '76px'
};

const spacerSizes = {
    ss0: '0px',
    ss1: '1px',
    ss2: '2px',
    ss3: '4px',
    ss4: '8px',
    ss5: '12px',
    ss6: '16px',
    ss7: '20px',
    ss8: '24px',
    ss9: '36px',
    ss10: '48px',
    ss11: '64px',
    ss12: '72px'
};

const newTheme = {
    colors,
    fontSizes,
    lineHeights,
    spacerSizes
};

const theme = {
    /**
     * @NOTE Please no longer use the styles from deprecatedStyles.
     * The following styles are from the new designs.
     * Please refactor old styles to use this new system 🙏
     */
    ...deprecatedStyles,
    ...newTheme
};

/**
 * Generate selectors for new theme
 * Usage e.g. color: ${selectors.butter};
 */
type Props = { theme: typeof theme };

// NOTE: If/when new props are added to newTheme, make sure to add the type here
type SelectorKeyType =
    | $Keys<typeof colors>
    | $Keys<typeof fontSizes>
    | $Keys<typeof lineHeights>
    | $Keys<typeof spacerSizes>;

/**
 * Flow has a problem inferring exact types when using spread (...)
 * So re-creating the spread functionality with this Generic type function
 */
const assign = <T>(a: T, ...b: $Shape<T>[]): T => Object.assign({}, a, ...b);

export const selectors = Object.keys(newTheme).reduce(
    (acc, key: $Keys<typeof newTheme>) =>
        assign(
            acc,
            Object.keys(newTheme[key]).reduce(
                (styles, styleKey: SelectorKeyType) =>
                    assign(styles, {
                        [styleKey]: ({ theme: scTheme }: Props): string =>
                            // $FlowFixMe flow thinks we are trying to get non-existent props, e.g. colors.fs1
                            scTheme[key][styleKey]
                    }),
                {}
            )
        ),
    {}
);

export default theme;



// WEBPACK FOOTER //
// ./src/core/themes/main/index.js